/** Standard z-index values based on UI context. Use least context and value possible. */
export const ZIndex = {
  /** Element: z-index for standard DOM elements that are not popovers or tooltips */
  Element: {
    Level1: 1,
    Level2: 2,
    Level3: 3,
    Level4: 4,
    Level5: 5,
    Level6: 6,
    Level7: 7,
    Level8: 8,
    Level9: 9,
  },
  NavigationSidebar: {
    Body: 10,
    Tooltip: 11,
    Popover: 12,
  },
  Tooltip: 15,
  Popover: {
    /** Popover.Body: popovers, some dropdowns and menus */
    Body: 16,
    /** Popover.Tooltip: tooltips inside popovers, to be passed to `@opallabs/lapidary` `<Tooltip>` */
    Tooltip: 17,
  },
  Sidebar: {
    Content: 21,
    Popover: 22,
    Tooltip: 23,
  },
  Drawer: {
    Overlay: 30,
    Content: 31,
    Footer: 32,
    Popover: 33,
    Tooltip: 34,
  },
  Shroud: {
    Overlay: 1999,
    Content: 2000,
    Footer: 2001,
    Popover: 2002,
    Tooltip: 2003,
  },
} as const
